import React from 'react';
import Header from './Header';
import Footer from './Footer';
import MusicCursor from '../shared/MusicCursor';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      {/* Skip to content link for accessibility */}
      <a href="#main-content" className="skip-to-content">
        Skip to main content
      </a>
      
      {/* Custom cursor effect */}
      <MusicCursor />
      
      <Header />
      <main id="main-content" className="flex-1 pt-16 md:pt-20">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
